import React, { useState } from 'react';

const PitchPlayers = ({ players, side, color }) => (
  <>
    {players.map((p, i) => {
      const cy = side === 'home' ? p.y : 100 - p.y;
      return (
        <g key={i} transform={`translate(${p.x}, ${cy})`} className="pitch-player">
          <circle r="4.5" fill={color} stroke="#fff" strokeWidth="0.5" />
          <text y="0.8" textAnchor="middle" fontSize="3.2" fontWeight="700" fill="#fff">{p.num}</text>
          <text y="9" textAnchor="middle" fontSize="2.6" fill="#fff" stroke="rgba(0,0,0,0.7)" strokeWidth="0.4" paintOrder="stroke">{p.name}</text>
        </g>
      );
    })}
  </>
);

export default function LineupsTab({ match }) {
  const lineups = match.lineups;
  const [view, setView] = useState('pitch'); // 'pitch' | 'list'

  if (!lineups) {
    return (
      <div className="tab-empty">
        <p>Lineups not announced yet.</p>
        <p className="tab-empty-sub">Lineups are usually published 1 hour before kickoff.</p>
      </div>
    );
  }

  const home = match.teams.home;
  const away = match.teams.away;

  return (
    <div className="lineups-view">
      <div className="lineups-header">
        <div className="lineups-team">
          <img src={home.logo} alt={home.name} />
          <span>{home.name}</span>
          <span className="formation-badge">{lineups.home.formation}</span>
        </div>
        <div className="view-toggle">
          <button className={view === 'pitch' ? 'active' : ''} onClick={() => setView('pitch')}>Pitch</button>
          <button className={view === 'list' ? 'active' : ''} onClick={() => setView('list')}>List</button>
        </div>
        <div className="lineups-team">
          <span className="formation-badge">{lineups.away.formation}</span>
          <span>{away.name}</span>
          <img src={away.logo} alt={away.name} />
        </div>
      </div>

      {view === 'pitch' ? (
        <div className="pitch-wrap">
          <svg viewBox="0 0 100 100" className="pitch-svg">
            {/* Pitch background */}
            <rect width="100" height="100" fill="#0a4d2a" />
            {/* Stripes */}
            {[...Array(10)].map((_, i) => (
              <rect key={i} x="0" y={i * 10} width="100" height="10" fill={i % 2 === 0 ? '#0d5a30' : '#0a4d2a'} />
            ))}
            {/* Outline */}
            <rect x="2" y="2" width="96" height="96" fill="none" stroke="#fff" strokeWidth="0.4" />
            {/* Halfway line */}
            <line x1="2" y1="50" x2="98" y2="50" stroke="#fff" strokeWidth="0.4" />
            {/* Center circle */}
            <circle cx="50" cy="50" r="9" fill="none" stroke="#fff" strokeWidth="0.4" />
            <circle cx="50" cy="50" r="0.6" fill="#fff" />
            {/* Boxes */}
            <rect x="20" y="2" width="60" height="14" fill="none" stroke="#fff" strokeWidth="0.4" />
            <rect x="35" y="2" width="30" height="6" fill="none" stroke="#fff" strokeWidth="0.4" />
            <rect x="20" y="84" width="60" height="14" fill="none" stroke="#fff" strokeWidth="0.4" />
            <rect x="35" y="92" width="30" height="6" fill="none" stroke="#fff" strokeWidth="0.4" />

            <PitchPlayers players={lineups.away.starters} side="away" color={away.color || '#df2946'} />
            <PitchPlayers players={lineups.home.starters} side="home" color={home.color || '#1d4ed8'} />
          </svg>
        </div>
      ) : (
        <div className="lineup-lists">
          <div className="lineup-list">
            <h4>Starting XI</h4>
            {lineups.home.starters.map((p, i) => (
              <div key={i} className="lineup-row">
                <span className="lineup-num">{p.num}</span>
                <span className="lineup-name">{p.name}</span>
                <span className="lineup-rating">{p.rating}</span>
              </div>
            ))}
            <h4 style={{ marginTop: 16 }}>Subs</h4>
            {lineups.home.substitutes.map((p, i) => (
              <div key={i} className="lineup-row sub">
                <span className="lineup-num">{p.num}</span>
                <span className="lineup-name">{p.name}</span>
              </div>
            ))}
          </div>
          <div className="lineup-list">
            <h4>Starting XI</h4>
            {lineups.away.starters.map((p, i) => (
              <div key={i} className="lineup-row">
                <span className="lineup-num">{p.num}</span>
                <span className="lineup-name">{p.name}</span>
                <span className="lineup-rating">{p.rating}</span>
              </div>
            ))}
            <h4 style={{ marginTop: 16 }}>Subs</h4>
            {lineups.away.substitutes.map((p, i) => (
              <div key={i} className="lineup-row sub">
                <span className="lineup-num">{p.num}</span>
                <span className="lineup-name">{p.name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
